import { DashboardGrid } from './layout/DashboardGrid'
import { useGoalsSync, useCustomersSync, useGroupBoxesSync } from '@/hooks/use-office-tv-sync'

export function OfficeTVPage() {
  // Load data from Supabase on mount, sync on changes via Zustand middleware
  useGoalsSync()
  useCustomersSync()
  useGroupBoxesSync()

  return (
    <div className="h-screen w-full overflow-hidden bg-background">
      <DashboardGrid />
    </div>
  )
}
